/**
 * AddressTextInput — the address TEXT, and nothing but the text.
 *
 * Holds the form's `location` value, whose shape is `{ address, latLng }`, but
 * exposes only the address string to the operator. The position now comes from
 * AddressSearchInput, which is a control of its own.
 *
 * ═══ WHY THE TWO WERE SPLIT ═══
 *
 * Until 2026-09-17 one field did both jobs: the operator typed a search query
 * into the box that held the address, so searching REWROTE the address. For a
 * register row written as "Fabriken" that is fatal — the operator has to type
 * something else entirely to find it, and the moment they do, "Fabriken" is
 * gone. Nothing stores the original (GF-65: 514 production rows already lost
 * theirs, recoverable only by re-import), and the 34 rows that went to review
 * on 2026-09-16 ARE that population. The feature built to rescue them would
 * have destroyed their names on the way.
 *
 * ⚠️ TYPING STILL CLEARS THE POSITION, exactly as the Mapbox box did. The guard
 * is unchanged on purpose: a rewritten address must not be saved on top of
 * coordinates that were chosen for a different one. Loosening it — letting text
 * and position drift independently because they now have separate controls —
 * would be a second decision, and it is not this one. The Lat/Long fields stay
 * a valid way through while the text is unchanged; see the validator in
 * Location.jsx.
 *
 * NOTE ON LANGUAGE: code and comments English, UI text Swedish — project rule.
 */
import React from "react";
import { Input } from "antd";

const AddressTextInput = ({ value, onChange, ...props }) => (
  <Input
    {...props}
    value={value?.address ?? ""}
    autoComplete="no"
    onChange={(event) =>
      onChange &&
      onChange({
        ...value,
        address: event.target.value,
        // Cleared, not preserved — see the note above.
        latLng: { lat: null, lng: null },
      })
    }
  />
);

export default AddressTextInput;
